import { useEffect, useCallback } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useDispatch } from "react-redux";

import { closeAllDrawers } from "reducers/drawer";

type KaboodleHotkeyWrapperProps = {
  children: React.ReactNode;
};

const KaboodleHotkeyWrapper = ({ children }: KaboodleHotkeyWrapperProps) => {
  const dispatch = useDispatch();

  const clearCallDrawers = useCallback(() => {
    dispatch(closeAllDrawers());
  }, [dispatch]);

  // when user pressed "back" button, clean state.
  useEffect(() => {
    const handlePopState = () => {
      clearCallDrawers();
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useHotkeys("esc", () => {
    clearCallDrawers();
  });

  return <>{children}</>;
};

export default KaboodleHotkeyWrapper;
